<template>
  <div class="">
    <div class="table-wrap">
      <a-row justify="start" type="flex" :gutter="22">
        <a-col :span="6">
          <a-input-search
            placeholder="请输入关键字"
            @search="onSearch"
            @change="onSearch"
            size="default"
            v-model="keyword"
          />
        </a-col>
        <a-col>
          <a-button
            type="primary"
            @click="openModal()"
            style="margin-right: 5px;"
            >添加课程</a-button
          >
          <a-popconfirm
            title="确定要删除吗 ?"
            @confirm="() => onDeleteInBatch()"
          >
            <a-icon slot="icon" type="question-circle-o" style="color: red" />
            <a-button type="default"><a-icon type="delete" />删除选中</a-button>
          </a-popconfirm>
        </a-col>
      </a-row>
      <a-row style="margin-top: 10px">
        <a-table
          :columns="columns"
          :rowKey="record => record.id"
          :dataSource="tableData"
          :bordered="true"
          :rowClassName="tableRowClass"
          :rowSelection="rowSelection"
          :pagination="pagination"
          @change="paginationChange"
        >
          <template slot="attach" slot-scope="text">
            <mini-tags :list="text" />
          </template>
          <template slot="icon" slot-scope="text">
            <a-avatar
              style="margin-right: 6px;"
              shape="square"
              size="large"
              :src="text"
              >无图</a-avatar
            >
          </template>
          <template slot="cell" slot-scope="text">
            <format-html :text="text" :keyword="keyword" />
          </template>
          <template slot="operation" slot-scope="text, record">
            <a
              @click="e => openModal(record.id)"
              href="javascript:;"
              style="margin-right: 20px;"
            >
              <a-icon type="edit" /> 修改
            </a>
            <a
              @click="e => onSetting(record.id)"
              href="javascript:;"
              style="margin-right: 20px;"
            >
              <a-icon type="setting" /> 设置
            </a>
            <a-popconfirm
              v-if="tableData.length"
              title="确定删除吗 ?"
              @confirm="() => onDelete(record.id)"
            >
              <a href="javascript:;"> <a-icon type="delete" /> 删除 </a>
            </a-popconfirm>
          </template>
        </a-table>
      </a-row>
    </div>
    <CourseForm v-model="visible" :afterSubmit="afterSubmit" :mode="mode" />
  </div>
</template>

<script>
import CourseForm from './CourseForm'
import { searchCourse, deleteCourse } from '@/api/course/course'
import moment from 'moment'

export default {
  components: {
    CourseForm
  },
  data() {
    return {
      columns: [],
      tableData: [],
      rowKeys: [],
      rowSelection: {
        onChange: selectedRowKeys => {
          this.rowKeys = selectedRowKeys
        }
      },
      pagination: {
        showSizeChanger: true,
        defaultCurrent: 1,
        defaultPageSize: 10,
        showTotal: total => {
          return `共 ${total} 条数据`
        }
      },
      keyword: '',
      visible: false,
      mode: {
        type: 'add',
        id: null
      },
      afterSubmit: () => {
        this.fetchData()
      }
    }
  },
  created() {
    this.columns = [
      {
        title: '封面',
        dataIndex: 'icon',
        scopedSlots: { customRender: 'icon' }
        // width: 55,
        // fixed: 'left'
      },
      {
        title: '课程名称',
        dataIndex: 'name',
        scopedSlots: { customRender: 'cell' }
        // width: 150,
        // fixed: 'left'
      },
      {
        title: '描述',
        dataIndex: 'description',
        scopedSlots: { customRender: 'cell' }
        // width: 200
      },
      {
        title: '难度级别',
        dataIndex: 'level',
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '讲师',
        dataIndex: 'teacher',
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '类型',
        dataIndex: 'category',
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '浏览次数',
        dataIndex: 'browseCount',
        scopedSlots: { customRender: 'cell' }
        // width: 100
      },
      {
        title: '创建时间',
        dataIndex: 'createdAt',
        scopedSlots: { customRender: 'cell' },
        customRender: text => {
          return moment(text).format('YYYY-MM-DD HH:mm:ss')
        }
      },
      {
        title: '上次修改时间',
        dataIndex: 'updatedAt',
        scopedSlots: { customRender: 'cell' },
        customRender: text => {
          return moment(text).format('YYYY-MM-DD HH:mm:ss')
        }
      },
      {
        title: '附件',
        dataIndex: 'attachs',
        scopedSlots: { customRender: 'attach' }
        // width: 100
      },
      {
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: { customRender: 'operation' }
        // width: 220,
        // fixed: 'right'
      }
    ]
    this.fetchData()
  },
  methods: {
    fetchData() {
      let { keyword, pagination } = this
      keyword = keyword.trim()
      const page = pagination.current || pagination.defaultCurrent
      const size = pagination.size || pagination.defaultPageSize
      searchCourse({ multiple: true, keyword, page, size }).then(resp => {
        let { result: res } = resp
        this.tableData = res.rows
        pagination.total = res.total
        this.pagination = JSON.parse(JSON.stringify(pagination))
      })
    },
    paginationChange(pagination) {
      this.pagination = pagination
      this.fetchData()
    },
    onSearch() {
      this.pagination.current = 1
      this.fetchData()
    },
    tableRowClass(record, index) {
      if (index % 2 === 0) {
        return 'row-class-even'
      } else {
        return 'row-class-odd'
      }
    },
    onDelete(id) {
      const ids = [id].join(',')
      this.delete(ids)
    },
    delete(ids = '') {
      deleteCourse({ ids }).then(() => {
        this.fetchData()
        this.$notification['success']({
          message: '成功',
          description: '删除成功',
          duration: 3
        })
      })
    },
    onDeleteInBatch() {
      const { rowKeys } = this
      if (rowKeys && rowKeys.length > 0) {
        const ids = rowKeys.join(',')
        this.delete(ids)
        this.fetchData()
      }
    },
    openModal(id) {
      this.visible = true
      if (id) {
        this.mode = {
          type: 'update',
          id
        }
      } else {
        this.mode = {
          type: 'add'
        }
      }
    },
    onSetting(id) {
      this.$router.push({
        name: 'section',
        query: {
          courseId: id
        }
      })
    }
  }
}
</script>
